import React from 'react'

function UnauthorizedPage() {
  return (
    <div>UnauthorizedPage</div>
  )
}

export default UnauthorizedPage